<template>
  <div>
    <div class="value-line">
      <p>Valor do pedido</p>
      <p>{{ Utils.convertMoney(total) }}</p>
    </div>
    <div class="value-line">
      <p>Taxa de entrega</p>
      <p>
        {{
          outOfRegion
            ? 'Fora da região de entrega'
            : freeFee
            ? 'Taxa grátis'
            : Utils.convertMoney(delivery || 0)
        }}
      </p>
    </div>
    <div class="value-line" v-if="discount > 0">
      <p>Descontos</p>
      <p>{{ Utils.convertMoney(discount) }}</p>
    </div>
    <div class="value-line" v-if="addition > 0">
      <p>Acréscimo</p>
      <p>{{ Utils.convertMoney(addition) }}</p>
    </div>
    <div class="value-line" v-if="gift && gift.code">
      <p>Cupom aplicado ({{ gift.code }})</p>
      <p>
        {{
          giftType[giftType.length - 1] == '%'
            ? `(` +
              giftType +
              `)` +
              'ㅤ-' +
              Utils.convertMoney(total * parseInt(giftType) * 0.01)
            : giftType[0] == 'R'
            ? `-` + giftType
            : giftType
        }}
      </p>
    </div>
    <!-- <div class="value-line">
        <p>Acréscimo</p>
        <p>2,00</p>
    </div> -->

    <div class="mb_30"></div>

    <div class="total-value">
      <p>Valor total</p>
      <p>
        {{
          Utils.convertMoney(total + delivery - discount + addition + giftValue)
        }}
      </p>
    </div>
  </div>
</template>
<script>
import Utils from '@/utils';
import { TYPE as GiftType } from 'easyjs/lib/Schema/Gift';

export default {
  props: {
    total: { default: 0 },
    delivery: { default: 0 },
    outOfRegion: false,
    freeFee: false,
    discount: {
      default: 0,
    },
    addition: {
      default: 0,
    },
    gift: {},
  },
  data() {
    return {
      Utils,
    };
  },
  computed: {
    giftType() {
      if (this.gift.typeIs(GiftType.DELIVERY)) {
        return 'Entrega Grátis';
      }

      if (this.gift.typeIs(GiftType.PERCENT)) {
        return `${this.gift.value}%`;
      }

      if (this.gift.typeIs(GiftType.PRICE)) {
        return Utils.convertMoney(this.gift.value, 'R$', '');
      }
    },
    giftValue() {
      return this.gift && this.gift.code
        ? this.gift.getValue(this.total, this.delivery)
        : 0;
    },
  },
};
</script>
<style scoped>
.value-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #aaaaab;
  margin-bottom: 5px;
  line-height: 15px;
}
.total-value {
  text-align: right;
}
.total-value p:first-child {
  text-transform: uppercase;
  color: #999999;
  font-size: 1.2em;
  line-height: 15px;
  margin-top: -5px;
}
.total-value p:last-child {
  color: #999999;
  font-size: 18px;
  font-weight: 900;
  line-height: 22px;
}
</style>
